import PropTypes from 'prop-types';
import { formatDuration } from '../../../../../utils/CommonUtils';
import TextBadgesList from './TextBadgesList';
import Flux from '../../../../../flux/Flux';

const TextBadgeFontColors = Flux.Constants.Grid2.TextBadge.FontColors;

const DurationBadge = (props) => {
	const textBadges = [
		{
			parts: [
				{
					text: formatDuration(props.duration, false),
					color: TextBadgeFontColors.WHITE,
				},
			],
		},
	];

	return <TextBadgesList textBadges={textBadges} />;
};

DurationBadge.propTypes = {
	duration: PropTypes.string.isRequired,
};

export default DurationBadge;
